define(function ( require ) {
    'use strict';

    var _ = require('underscore');
    var Backbone = require('backbone');
    var Marionette = require('marionette');

    var callsTpl = require('text!tmpls/parts/caller/calls.tpl').default;
    var contactTpl = require('text!tmpls/parts/caller_left/item.tpl').default;

    var ContactCollection = require('collections/contacts');
    var StaffCallContactPopover = require('popovers/staff_call_to_contact/view');
    var SmsEditPopover = require('popovers/sms_edit/view');
    var EmailEditPopover = require('modals/email_edit/view');
    var EmailModel = require('models/email');
    var PopoverBehavior = require('behaviors/popover');
    var ModalBehavior = require('behaviors/modal');
    var AppConfig = require('config/application');
    var itemNoRes = require('text!tmpls/parts/caller_left/no_res.tpl').default;


    var Model = Backbone.Model.extend({
        search: true
    });

    var ContactsList = Marionette.ItemView.extend({
        template: contactTpl,
        className: 'b-mc__body scrollbar-macosx'
    });

    var EmptyContacts = Marionette.ItemView.extend({
        template: itemNoRes
    });

    return Marionette.LayoutView.extend({
        template: callsTpl,
        model: new Model(),

        regions: {
            regionContacts: '.js-region-contacts'
        },

        ui: {
            'deleteCall': '.js-delete-call',
            'collapseProject': '.js-collapse-project',
            'missedItem': '.js-missed-item',
            'callBtn': '.js-contact-phone-call',
            'smsBtn': '.js-contact-sendsms',
            'emailBtn': '.js-contact-sendemail',
            'inputPhone': 'input[name=phone]',
            'inputName': '.js-call_input_name',
            'cleanInputSearch': '.js-caller-clean-search',
            'cleanInputCall': '.js-caller-clean-call',
            'openContact': '.js-caller-open-contact',
            'clickPhone': '.js-caller-phone',
            'call_btn_mobile': '.call_btn_mobile',
            'btnSendSms': '.btn_send_sms'
        },

        events: {
            'click @ui.missedItem': 'openContact',
            'mousedown  @ui.callBtn': 'onPressPhoneCall',
            'click @ui.callBtn': 'stopBubling',
            'click @ui.smsBtn': 'onClickSendSms',
            'click @ui.emailBtn': 'onClickSendEmail',
            'click @ui.cleanInputSearch': 'cleanInputSearch',
            'click @ui.cleanInputCall': 'cleanInputCall',
            'click @ui.openContact': 'slideContact',
            'click @ui.clickPhone': 'clickContactPhone',
            'click @ui.btnSendSms': 'sendSmsToPhone',
            'click @ui.call_btn_mobile': 'callMobile'
        },

        behaviors: {
            'popover': {
                behaviorClass: PopoverBehavior
            },
            'modal': {
                behaviorClass: ModalBehavior
            }
        },

        initialize: function () {
            this.$el.on('keydown', '.js-call_input_name', _.debounce(this.searchByName.bind(this), 500));
            this.$el.on('keydown', '#js-call_to_phone', _.debounce(this.searchByPhone.bind(this), 500));

            app.Collections.contacts = new ContactCollection();
            this.listenTo(app.Collections.contacts, 'add', this.addedContact);
            this.contactsCollection = app.Collections.contacts;
            this.listenToOnce(this.contactsCollection, 'sync', function ( data ) {
                this.collectionToArray();
            });
        },

        onRender: function () {
            this.getContacts();
            $(this.ui.inputPhone).phoneinput();
        },

        openContact: function ( event ) {
            var contactId = $(event.currentTarget).data('contact-id');
            var projectId = $(event.currentTarget).data('project-id');
            window.location.href = '/#contacts/card/' + contactId;
            $('.js-btn-calls').click();
            if (projectId != app.Models.curProject.id) {
                Backbone.ajax({
                    type: 'POST',
                    url: AppConfig.host + '/rest/system/change_project/' + projectId,
                    success: function () {
                        if ('caches' in window) {
                            caches.keys()
                                .then(function ( cacheNames ) {
                                    cacheNames.map(function ( cacheName ) {
                                        if (cacheName == 'lptracker-data-v2') {
                                            caches
                                                .delete(cacheName)
                                                .catch(function ( error ) {
                                                    console.warn('Caches delete failed with ' + error);
                                                });
                                        }
                                    });
                                })
                                .catch(function ( error ) {
                                    console.warn('Caches keys failed with ' + error);
                                });
                        }
                        window.location.reload();
                    }
                });
            }
        },

        stopBubling: function ( event ) {
            event.stopPropagation();
        },

        onPressPhoneCall: function ( event ) {
            var that = this;
            var startTime = Date.now();
            var target = event.currentTarget;
            var timeout = setTimeout(function () {
                var handler = function ( widget ) {
                    that.listenToOnce(widget, 'employee:selected', function ( data ) {
                        that.phoneCall.call(that, event, data.employee, data.type);
                    });
                };
                that.triggerMethod('showPopover', {
                    view: StaffCallContactPopover,
                    target: target,
                    handler: handler
                });
            }, 1000);
            event.stopPropagation();
            event.preventDefault();
            $(event.currentTarget).one('mouseup', function ( e ) {
                event.stopPropagation();
                var stopTime = Date.now();
                var duration = stopTime - startTime;
                if (duration <= 1000) {
                    clearTimeout(timeout);
                    that.phoneCall.call(that, event);
                }
            });
        },

        phoneCall: function ( e, employee, type ) {
            e.stopPropagation();
            e.preventDefault();

            var that = this;
            var target = $(e.currentTarget);
            var id = target.data('id');
            var missCall = app.Collections.MissCalls.get(id);
            var number = missCall && missCall.get('number');
            var callType;
            var data;

            if (type !== undefined) {
                callType = type;
            } else if (app.Models.User.get('calls_to_sip')) {
                callType = 0;
            } else if (app.Models.User.get('calls_to_mobile')) {
                callType = 1;
            } else if (app.Models.User.get('calls_to_sim')) {
                callType = 2;
            }

            data = {
                call_type: callType,
                phone: number
            };

            if (employee) {
                data.user_id = employee.id;
                data.user_type = employee.get('profile_type');
            }
            app.checkCallTime('phone', data.phone, function(){
                Backbone.ajax({
                    url: AppConfig.host + '/rest/contacts/call_to_number',
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    success: function ( response ) {
                        if (~~response.status === 1) {
                            if (!employee) {
                                app.message.success(response.message);
                            } else {
                                app.message.success('Звонок отправлен сотруднику');
                            }
                        } else {
                            app.message.error(response.message);
                        }
                    },
                    error: function ( xhr ) {
                        var response = $.parseJSON(xhr.responseText);
                        app.message.error(response.message || 'Ошибка');
                    }
                });
            });
        },

        callToPhone: function ( options, checkRate = true, notCheckRate = false  ) {
            var that = this;
            var input = $('#js-call_to_phone');
            /**
             * @type {string}
             */
            var phone = $(input).val();
            var id = $(input).data('contact_id');
            var call_type = options.type;

            var byContact = phone.indexOf('*') != -1 && id > 0;

            var method = byContact ? 'call' : 'call_to_number';
            var data = {
                call_type: call_type
            };

            if (byContact) {
                data.phone_id = id;
            } else {
                data.phone = phone;
            }

            data.check_rate = checkRate;
            data.not_check_rate = notCheckRate;

            Backbone.ajax({
                type: 'POST',
                url: AppConfig.host + '/rest/contacts/' + method,
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: function ( response ) {
                    if(response.rate == -1) {
                        app.message.confirm(response.message,
                            function () {
                                window.location.hash = '#calls-scheme-settings?show=main'
                            },
                            function () {
                                that.callToPhone(options, false, $("input[name=notCheckRate]:visible").is(':checked'));
                            },
                            {
                                okText: 'Изменить номер',
                                cancelText: 'Позвонить'
                            }
                        );
                        return;
                    }
                    if (response.status == AppConfig.STATUS_OK) {
                        app.message.success(response.message);
                    } else {
                        app.message.error(response.message);
                    }
                },
                error: function ( xhr ) {
                    var response = $.parseJSON(xhr.responseText);
                    app.message.error(response.message || 'Ошибка');
                }
            });
        },

        onClickSendSms: function ( event ) {
            var that = this;
            var target = $(event.currentTarget);
            var id = '' + target.data('contactId');
            event.stopPropagation();
            this.triggerMethod('showPopover', {
                view: SmsEditPopover,
                target: target,
                handler: function ( widget ) {
                    that.listenToOnce(widget, 'sms:edited', function ( message ) {
                        var data = {
                            contact_ids: id,
                            text: message
                        };
                        that.sendSms.call(that, data);
                    });
                }
            });
        },

        onClickSendEmail: function ( event ) {
            var that = this;
            var target = $(event.currentTarget);
            var model = new EmailModel();
            var id = '' + target.data('contactId');
            event.stopPropagation();
            var dialog = new EmailEditPopover({
                curElement: $(target),
                modalData: {
                    model: model
                }
            });
            this.triggerMethod('showModal', dialog);
            this.listenToOnce(dialog, 'email:edited', function (isHtml) {
                var data = {
                    contact_ids: id,
                    subject: model.get('subject'),
                    text: model.get('text'),
                    type: isHtml ? 'html' : 'text'
                };
                if (model.get('from')) {
                    data.from = model.get('from');
                }
                that.sendEmail.call(that, data);
            });
        },

        sendSms: function ( data ) {
            if (data.contact_ids.length) {
                var msg = app.message.success('Отправка Sms', false);
                this._xhr = Backbone.ajax({
                    url: AppConfig.host + '/rest/contacts/sms',
                    contentType: 'application/json',
                    type: 'POST',
                    data: JSON.stringify(data),
                    success: function ( response ) {
                        msg.hide();
                    },
                    error: function ( xhr ) {
                        var data = xhr.responseJSON;
                        app.message.error(data.message);
                    }
                });
            } else {
                app.message.error('Нет выбранных номеров');
            }
        },

        sendEmail: function ( data ) {
            if (data.contact_ids.length) {
                var msg = app.message.success('Отправка Email', false);
                this._xhr = Backbone.ajax({
                    url: AppConfig.host + '/rest/contacts/email',
                    contentType: 'application/json',
                    type: 'POST',
                    data: JSON.stringify(data),
                    success: function ( response ) {
                        msg.hide();
                        if (response.status !== 1) {
                            app.message.error(response.message);
                        }
                    },
                    error: function ( xhr ) {
                        var data = xhr.responseJSON;
                        app.message.error(data.message);
                    }
                });
            } else {
                app.message.error('Нет выбранных email адресов');
            }
        },

        searchByName: function ( e ) {
            var search = this.ui.inputName.val() || '';
            this.ui.inputPhone.val('');
            if (search.length) {
                this.getContacts({query: search});
            }
        },

        searchByPhone: function () {
            var search = this.ui.inputPhone.val() || '';
            this.model.set('search', '');
            if (search.length) {
                this.getContacts({phone: search});
            }
        },

        getContacts: function ( data ) {
            var self = this;
            data = data || {};
            app.Collections.contacts.reset();

            app.Collections.contacts.fetch({
                data: data,
                success: function () {
                    if (self.isDestroyed) {
                        return;
                    }
                    self.contactsCollection = app.Collections.contacts;
                    if (self.contactsCollection.length > 0) {
                        self.collectionToArray();
                    }
                    if (self.contactsCollection.length === 0) {
                        self.showEmptyContacts();
                    }
                }
            });
        },

        collectionToArray: function () {
            var that = this, first_letter, total, phones = [], item = {};

            for (var i = 0; i < this.contactsCollection.models.length; i++) {
                var model = this.contactsCollection.models[i];

                first_letter = model.get('name').charAt(0).toUpperCase();
                phones = $.map(model.get('phones'), function ( value, index ) {
                    return [value];
                });

                total = model.get('total');

                if (typeof item[first_letter] == 'undefined') item[first_letter] = [];

                item[first_letter].push({
                    name: model.get('name'),
                    phones: phones,
                    id: model.id
                });
            }

            var overLength = false;
            if (this.contactsCollection.models.length < total) {
                overLength = true;
            }

            that.model.set({
                item: item,
                overLength: overLength
            });
            that.showContacts();
        },

        showContacts: function () {
            this.showChildView('regionContacts', new ContactsList({model: this.model}));
            this.$('.js-search').show();
            this.$('.scrollbar-macosx').scrollbar();
        },

        showEmptyContacts: function () {
            this.regionContacts.show(new EmptyContacts());
        },

        cleanInputSearch: function ( e ) {
            if ($(e.currentTarget).prev().val() != '') {
                $(e.currentTarget).prev().val('');
            }
            this.getContacts();
        },

        cleanInputCall: function ( e ) {
            console.log('clear');
            this.ui.inputPhone.val('');
            this.getContacts();
        },

        slideContact: function ( e ) {
            var current = $(e.currentTarget);
            if (current.hasClass('b-caller__letter_passive')) {
                current.removeClass('b-caller__letter_passive').addClass('b-caller__letter_active');
                current.next('div').slideDown(400);
            }
            else {
                current.removeClass('b-caller__letter_active').addClass('b-caller__letter_passive');
                current.next('div').slideUp(400);
            }
        },

        clickContactPhone: function ( e ) {
            var number = $(e.currentTarget).text();
            var id = $(e.currentTarget).data('id');
            this.$('.b-caller__input').val(number);
            this.$('.b-caller__input').data('contact_id', id);
        },

        callMobile: function ( event ) {
            this.callToPhone({type: 'mobile'});
        },

        sendSmsToPhone: function ( event ) {
            var that = this;
            var target = event.target;
            var input = $('#js-call_to_phone');
            event.stopPropagation();
            this.triggerMethod('showPopover', {
                view: SmsEditPopover,
                target: target,
                handler: function ( popover ) {
                    that.listenToOnce(popover, 'sms:edited', function ( message ) {
                        var data = {
                            to: input.val(),
                            text: message
                        };
                        if (data.to.length) {
                            var msg = app.message.success('Отправка Sms', false);
                            that._xhr = Backbone.ajax({
                                url: AppConfig.host + '/rest/contacts/sms',
                                contentType: 'application/json',
                                type: 'POST',
                                data: JSON.stringify(data),
                                success: function ( data ) {
                                    msg.hide();
                                },
                                error: function ( xhr ) {
                                    var data = xhr.responseJSON;
                                    app.message.error(data.message);
                                }
                            });
                        } else {
                            app.message.error('Нет выбранных номеров');
                        }
                    });
                }
            });
        }
    });
});
